<template>
  <vg-field
      :class="{disabled: disabled}"
      v-bind="$attrs"
      :label="label"
      :placeholder="`请输入${label}`"
      :disable="disabled"
      :value="value"
      rows="1"
      @input="input"
  />
</template>

<script>
import VgField from "@/components/Commons/VgField.vue";

export default {
  name: "DpApplicationPhoneNumberField",
  components: {VgField},
  props: {
    label: String,
    value: String,
    disabled: Boolean,
  },
  methods: {
    input(value) {
      if (/^[0-9]*$/.test(value)) {
        this.$emit('input', value)
      }
    }
  }
}
</script>

<style scoped>
.disabled >>> input,
.disabled >>> textarea {
  color: #B4B4B4;
}
</style>
